import React from 'react';
import { DialogTitle, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DialogHeaderProps {
  title: string;
  icon: React.ReactNode;
  onClose: () => void;
  disabled?: boolean;
}

/**
 * Reusable dialog header component with icon, title, and close button.
 * Provides consistent styling across all dialogs.
 */
export const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  icon,
  onClose,
  disabled = false,
}) => (
  <DialogTitle
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {icon}
      <Typography variant="h6">{title}</Typography>
    </Box>
    <IconButton
      onClick={onClose}
      size="small"
      disabled={disabled}
      aria-label="close"
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
);

export default DialogHeader;
